import _ from 'lodash';
import { enqueueSnackbar } from 'notistack';
import dayjs, { Dayjs } from 'dayjs';

export const filterOptions = (options: Array<{}>, inputText: string, idPais: number) => {
    const normalizeText = (text: string) => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const filteredOptionsByIdPais = options?.filter((i: any) => i.idPais === idPais);
    const array = filteredOptionsByIdPais?.filter((i: any) =>
        normalizeText(i.nombre).toLowerCase().includes(normalizeText(inputText).toLowerCase())
    );
    return array || [{ nombre: 'No options', id: 0 }];
};

export const downloadFile = ({ blob, name }: any) => {
    const href = URL.createObjectURL(blob);
    const file = document.createElement('a');
    file.href = href;
    file.download = name;
    file.click();
    file.remove();
    URL.revokeObjectURL(href);
};

export const validateAccess = (functions: any, id: number) => {
    let accesible = false;

    if (functions?.funcionalidades.find((i: any) => i.id === id)) accesible = true;

    return accesible;
};

export const getDate = (date: any) => {
    if (!date) return '';
    const newDate = new Date(date);
    return dayjs(newDate.toISOString()).format('DD/MM/YYYY');
};

/** Fecha calendario del backend (UTC) → DD/MM/YYYY sin desplazamiento por zona horaria */
export const formatDateOnly = (date: string | null | undefined): string => {
    if (!date) return '';
    const d = new Date(date);
    const day = String(d.getUTCDate()).padStart(2, '0');
    const month = String(d.getUTCMonth() + 1).padStart(2, '0');
    return `${day}/${month}/${d.getUTCFullYear()}`;
};

/** Fecha calendario del backend (UTC) → dayjs en medianoche local con el día correcto */
export const parseDateOnly = (date: string | Dayjs | null | undefined): Dayjs | null => {
    if (!date) return null;
    if (dayjs.isDayjs(date)) return date;
    const d = new Date(date);
    if (isNaN(d.getTime())) return null;
    return dayjs(new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()));
};

export const getDateTime = (date: any) => {
    if (!date) return '';
    const newDate = new Date(date);
    return dayjs(newDate.toISOString()).format('DD/MM/YYYY HH:mm');
};

export const downloadBase64File = (data: string, id: number, name?: string) => {
    const linkSource = `data:application/pdf;base64,${data}`;
    const downloadLink = document.createElement('a');
    const fileName = name ? `${name + '-' + id}.pdf` : `solicitud-de-giro-${id}.pdf`;
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
};

export const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

export const handleErrors = (errors: any) => {
    if (Array.isArray(errors?.data?.message)) {
        return errors.data.message.forEach((msg: any) => {
            enqueueSnackbar(msg, {
                variant: 'error'
            });
        });
    } else {
        return enqueueSnackbar(errors?.data?.message || 'Ocurrió un error', {
            variant: 'error'
        });
    }
};

export function filterByKey<T extends Record<string, any>>(data: T[], query: string, key: string) {
    return data.filter((item: T) => item[key] === query);
}

export function urlPatternValidation(url: string): boolean {
    return new RegExp('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?').test(url);
}

type ValueProps = {
    options: [];
    id?: number;
    nombre?: string;
};
export const getValue = ({ options, id, nombre }: ValueProps) => {
    if (!options) return;
    return options?.find((i: any) => i.id === id || i.nombre === nombre) || null;
};

export const tenantDateValidation = ({ data, shipData }: any) => {
    if (!data?.locatario || !shipData?.locatario) return false;
    if (!data?.locatario?.fechaDesde && !data?.locatario?.fechaHasta) return;
    const since = new Date(data?.locatario?.fechaDesde);
    const until = new Date(data?.locatario?.fechaHasta);

    if (!isNaN(since?.getTime()) && !isNaN(until?.getTime())) {
        const defaultDates = {
            fechaDesde: shipData?.locatario?.fechaDesde,
            fechaHasta: shipData?.locatario?.fechaHasta
        };

        const currentDates = {
            fechaDesde: since?.toISOString(),
            fechaHasta: until?.toISOString()
        };

        const existId = shipData?.locatario?.id === data?.locatario?.id;
        return existId && _.isEqual(defaultDates, currentDates);
    }
};

export const isValidDate = (value: any) => {
    if (!value) return null;
    const date = new Date(value);
    return !isNaN(date?.getTime());
};

export const getESICertificate = (data: any) => {
    let value: string = '-';

    const ESICert = data?.buque?.certificados?.find(
        (i: any) => i?.tipoCertificado?.id === 9 && i?.estado === 'AP'
    );

    if (ESICert) {
        if (ESICert?.rutaAdjunto) {
            value = ESICert.puntaje;
        } else if (ESICert?.compromisoPresentacion) {
            value = 'Compromiso de presentación';
        }
    }

    return value;
};

export const ID_PERFIL_ADMIN_PUERTOS = 1;
export const MODIFICANDO_REVISION = 'modificando_revision';